module.exports = __webpack_public_path__ + "static/img/缺考说明.a069719.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/v2/assets/images/缺考说明.jpg
// module id = iwYb
// module chunks = 129